<template>
    <div>
        <v-container v-if="loadSkeleton">
            <SkeletonLoader tipo="table-heading, card" ruta="dashboard" />
        </v-container>
        <v-container v-else>
            <!-- El aviso "Ya se encuentra habilitada la opcion de nivel" ya no se arma
                 aca: lo genera el back y llega por el modulo de avisos. -->
            <!--   <DialogoFaltaFoto ref="refDialogoActualizaFoto" type="foto" @handleReturn="" />
            <DialogoFaltaFoto ref="refDialogoActualizaContacto" type="contacto" /> -->
            <DeudaCard v-if="(user.tienedeuda !== 0)" />
            <v-row class="mx-0">
                <v-col cols="12" md="12" class="d-flex justify-start pa-0 ma-0">
                    <v-card-title class="text-h5 font-weight-bold">
                        <v-icon color="primary" class="mr-2" size="34">mdi-account-outline</v-icon>
                        Mi legajo
                    </v-card-title>
                </v-col>
                <v-col cols="12" md="5">
                    <AfiliadoCard />
                </v-col>
                <v-col cols="12" md="7">
                    <v-row>
                        <v-col cols="12">
                            <ContactCard title="Información de contacto" />
                        </v-col>
                        <v-col cols="12">
                            <FamiliaresCard></FamiliaresCard>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactCard from '@/components/cards/ContactCard.vue'
import FamiliaresCard from '@/components/cards/FamiliaresCard.vue'
import CredencialCard from '@/components/cards/CredencialCard.vue'
import AfiliadoCard from '@/components/cards/AfiliadoCard.vue'
import DeudaCard from '@/components/cards/DeudaCard.vue'
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'
import InputButtonDniFrente from '@/components/inputs/InputButtonDniFrente.vue'
import InputButtonDniDorso from '@/components/inputs/InputButtonDniDorso.vue'
import DialogoCredencial from '@/components/dialogos/DialogoCredencial.vue';
/* import DialogoFaltaFoto from '@/components/dialogos/DialogoFaltaFoto.vue' */

export default {
    name: "Dashboard",

    components: {
        AfiliadoCard,
        DeudaCard,
        ContactCard,
        FamiliaresCard,
        CredencialCard,
        SkeletonLoader,
        InputButtonDniFrente,
        InputButtonDniDorso,
        //DialogoFaltaFoto,
        DialogoCredencial,
    },


    data() {
        return {

            tipo: '',

        }
    },
    mounted() {
        //this.levantarCommon()
        /*         this.$nextTick(() => {
                    this.checkDialogosReady();
                }); */
    },
    watch: {
        /*         pedirFoto(newVal, oldVal) {
                    this.checkDialogosReady();
                },
                pedirDatosContacto(newVal, oldVal) {
                    this.checkDialogosReady();
                },
                $route(to) {
                    // Verificar si la ruta es 'dashboard' y si el usuario está autenticado
                    if (to.name == 'dashboard' && this.isAuthenticated) {
                        this.$nextTick(() => {
                            this.checkDialogosReady()
                        });
                    }
                } */
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'user', 'loadSkeleton', 'esActivo', 'esJubilado', 'tienedeuda', 'pedirFoto', 'pedirDatosContacto']),
        ...mapGetters('preafiliacion', ['itemNivel']),
    },
    methods: {
        ...mapActions(['refreshData']),
        ...mapActions('tramites', ['getTramites']),
        ...mapActions('opcionNivel', ['getNivelAfiliado']),
        ...mapActions('common', ['levantarCommon']),

        /*  checkDialogosReady() {
             // Solo llamar a verificarDialogos si ambos valores no son undefined y estamos en Dashboard
             if (
                 this.$route.name === 'dashboard' &&
                 this.pedirFoto !== undefined &&
                 this.pedirDatosContacto !== undefined
             ) {
                 this.verificarDialogos();
             }
         },
 
         async verificarDialogos() {
             const refFoto = this.$refs.refDialogoActualizaFoto;
             const refContacto = this.$refs.refDialogoActualizaContacto;
             if (this.pedirFoto == 1 && this.pedirDatosContacto == 1) {
                 if (refFoto && refFoto.abrirDialogo && refContacto && refContacto.abrirDialogo) {
                     await refFoto.abrirDialogo();
                     await refContacto.abrirDialogo();
                 }
             } else if (this.pedirFoto == 1) {
                 if (refFoto && refFoto.abrirDialogo) {
                     await refFoto.abrirDialogo();
                 }
             } else if (this.pedirDatosContacto == 1) {
                 if (refContacto && refContacto.abrirDialogo) {
                     await refContacto.abrirDialogo();
                 }
             }
         }, */

        lanzarCredencial() {
            this.titulo = "Credencial virtual"
            this.$refs.dialCred.abrirDialogo()
        }
    },
}

</script>
